const Query = props => {
  const { invoicesV2 } = props || {};
  const { sqlQuery } = invoicesV2 || {};

  return <div>{sqlQuery}</div>;
};

export default Query;
